/**
 * 单品备注
 */
import React from 'react'
import { observer } from 'mobx-react'
import { storeMobx, cartMobx } from 'restaurant'
import { ConfirmModal, UseTextArea, Icon } from '@cps'
import { modalLayer } from '@utils'
import { classNames } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  pk: string;
  remark: string;
}

const SingleRemarkBar: React.FC<IProps> = ({ pk, remark }) => {
  if (storeMobx.info.isOpenSingleRemark !== 1) return null

  const handleSetRemark = (event: React.MouseEvent) => {
    event.stopPropagation()
    let _remark = remark
    modalLayer(ConfirmModal, {
      title: i18n.t('cart.inputRemark'),
      confirmText: i18n.t('common.confirm'),
      cancelText: i18n.t('common.cancel'),
      backdropDismiss: false,
      children: (
        <UseTextArea
          data-cypid={`cartSingleRemarkInput_pk_${pk}`}
          maxLength={140}
          value={remark}
          showLength={118}
          placeholder={i18n.t('cart.singleremartplacechoder')}
          onChange={(e: any) => { _remark = e }}
        />
      ),
      className: 'cart-single-remark-modal'
    }, 'cart-single-remark-modal').then(() => {
      cartMobx.setCartSingleRemark(_remark, pk)
    }).catch((err) => {
      console.log(err)
    })
  }

  return (
    <div className='cart-single-remark-container'>
      <div className={classNames('single-remark-btn', { active: remark?.length > 0 })} data-cypid={`cartSingleRemark_pk_${pk}`} onClick={handleSetRemark}>
        <Icon name='beizhu1' />
      </div>
    </div>
  )
}

export default observer(SingleRemarkBar)
